module.exports = __webpack_public_path__ + "static/media/tel.ddc61711.png";